export default __webpack_public_path__ + "static/media/5.0b4bb8c7.svg";